<template>
  <div class="new-collision-check h-full overflow-hidden relative">
    <categoryTitle class="mt-10px" title="创建检查" />
    <div class="py-8px flex justify-center item-select-box">
      <el-select
        v-model="subjectNode"
        placeholder="请选择碰撞主体"
        clearable
        class="mr-5px w-4/5"
        size="mini"
        ref="subjectSelect"
        popper-class="visualization-select-popper"
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          v-model="treeFilterKey"
          size="mini"
          clearable
          @keypress.native.enter="filterModelTree('subject')"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="filterModelTree('subject')"
          ></i>
        </el-input>
        <el-option hidden key="1" :label="subjectNodeName" :value="subjectNode"></el-option>
        <el-tree
          v-if="treeDataLoad"
          class="subjectModelTree max-h-200px mt-5px w-280px overflow-auto"
          :props="treeProps"
          ref="subjectModelTree"
          :data="subjectTreeData"
          :load="loadNode"
          highlight-current
          :lazy="true"
          :filter-node-method="filterNode"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="(data) => clickModelTree(data, 'subject')"
          node-key="item"
        ></el-tree>
      </el-select>
    </div>
    <div class="py-8px flex justify-center item-select-box">
      <el-select
        v-model="objectNode"
        placeholder="请选择碰撞客体"
        clearable
        class="mr-5px w-4/5"
        size="mini"
        ref="objectSelect"
        popper-class="visualization-select-popper"
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          v-model="objectTreeFilterKey"
          size="mini"
          clearable
          @keypress.native.enter="filterModelTree('object')"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="filterModelTree('object')"
          ></i>
        </el-input>
        <el-option hidden key="1" :label="objectNodeName" :value="objectNode"></el-option>
        <el-tree
          v-if="objectTreeDataLoad"
          class="objectModelTree max-h-200px mt-5px w-280px overflow-auto"
          :props="treeProps"
          ref="objectModelTree"
          :data="objectTreeData"
          :load="loadNode"
          highlight-current
          :lazy="true"
          :filter-node-method="filterNode"
          :default-expanded-keys="objectDefaultExpandedKeys"
          @node-click="(data) => clickModelTree(data, 'object')"
          node-key="item"
        ></el-tree>
      </el-select>
    </div>
    <el-button
      @click="startCheck"
      v-loading="checkBtnLoading"
      size="small"
      type="primary"
      class="ml-20px"
      >开始检查</el-button
    >
    <categoryTitle class="mt-10px" title="检查结果" />
    <el-table
      :data="tableData"
      :height="`calc(100% - 196px)`"
      highlight-current-row
      row-key="id"
      class="new-collision-table"
      stripe
      v-loading="tableLoading"
      @row-click="rowClick"
    >
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="mainName" label="主体" show-overflow-tooltip></el-table-column>
      <el-table-column prop="guestName" label="客体" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="{ row }">
          <span @click="resultSave(row)" size="small" class="text-[#44F1FF] cursor-pointer"
            >保存</span
          >
        </template>
      </el-table-column>
      <div slot="empty" class="w-full h-full flex justify-center items-center">
        <span>暂无数据</span>
      </div>
    </el-table>
    <div
      :class="locatingStatus ? 'visible' : 'invisible'"
      class="locating-box transition-all left-140px duration-500 absolute w-65px h-65px top-380px bg-[#00000059] rounded-10px text-[#00e3dd] flex flex-col items-center p-5px"
    >
      <i class="el-icon-loading text-32px"></i>
      <span class="text-14px mt-5px">定位中</span>
    </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import xml2js from 'xml2js'
import { multipleLocations } from './js/publicModelMays'
import EventBus from './js/eventBus'

const parser = new xml2js.Parser()

export default {
  name: 'CollisionCheck',
  components: { categoryTitle },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collisionMaterialObj: {
      type: Object,
      defalut: {},
    },
  },
  data() {
    return {
      locatingStatus: false,
      treeDataLoad: false,
      objectTreeDataLoad: false,
      banLazy: false, // 用于禁止重置目录树数据时，多次触发懒加载
      tableLoading: false,
      checkBtnLoading: false,
      pageNo: 1,
      pageSize: 15,
      total: 0,
      treeData: [], // 模型树数据
      objectTreeData: [],
      subjectTreeData: [],
      previewSubNodePtr: null,
      previewObNodePtr: null,
      subMaterial: null,
      obMaterial: null,
      treeFilterKey: null,
      objectTreeFilterKey: null,
      subjectNode: null,
      subjectNodeName: null,
      objectNode: null,
      objectNodeName: null,
      subjectPhysical: null, // 主体物理
      objectPhysical: null, // 客体物理
      currentNodeInfo: {},
      materialObj: {
        previewSubNodePtr: null,
        previewObNodePtr: null,
        subMaterial: null,
        obMaterial: null,
      },
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
      defaultExpandedKeys: [], // 展开节点
      objectDefaultExpandedKeys: [], // 客体
      tableData: [],
    }
  },
  watch: {},
  methods: {
    // 筛选方法
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 定位树节点
    locationNode(item, type) {
      const str = type === 'subject' ? 'subjectModelTree' : 'objectModelTree'
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[str].setCurrentKey(item)
          setTimeout(() => {
            const node = document.getElementsByClassName(str)[0]
            const curNodeArr = document.getElementsByClassName('is-current')
            let currentNode
            if (curNodeArr.length > 1) {
              currentNode =
                type === 'subject'
                  ? document.getElementsByClassName('is-current')[0]
                  : document.getElementsByClassName('is-current')[1]
            } else {
              currentNode = document.getElementsByClassName('is-current')[0]
            }
            window.currentNode = currentNode
            node.scrollTo({
              top: currentNode.offsetTop,
            })
          }, 500)
        }, 500)
      })
    },
    // 模型树点击操作
    clickModelTree(data, type, isSearchStatus = false) {
      const strArr =
        type === 'subject'
          ? ['subjectNode', 'subjectNodeName', 'subjectSelect']
          : ['objectNode', 'objectNodeName', 'objectSelect']
      if (data.item) {
        this[strArr[0]] = data.item
        this[strArr[1]] = data.name
        multipleLocations(this.player, data)
        if (!isSearchStatus) {
          this.$refs[strArr[2]].blur()
        }
      } else {
        this.$message.warning('该节点不存在')
      }
    },
    // 展开节点树
    async expendNode(nodeInfo, type) {
      // item: 1为pr模型跟， nodeInfo.parentItem = 0为杆塔模型的跟
      if (nodeInfo.item === 1 || nodeInfo.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNodeInfo, type, true)
          this.locationNode(this.currentNodeInfo.item, type)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          nodeInfo.parentItem
        )
        // 展开
        const expandStr = type === 'subject' ? 'defaultExpandedKeys' : 'objectDefaultExpandedKeys'
        this[expandStr].push(res.item)
        await this.expendNode(res, type)
      }
    },
    async filterModelTree(type) {
      this.currentNodeInfo = {}
      const keyword = type === 'subject' ? this.treeFilterKey : this.objectTreeFilterKey
      const treeDataStr = type === 'subject' ? 'subjectTreeData' : 'objectTreeData'
      if (!keyword) {
        setTimeout(() => {
          this[treeDataStr] = this.treeData
        }, 500)
        return
      }
      // 过滤模型树
      this.currentNodeInfo = await PlayerUtils.call(
        this.player.Native.ModelTree.findItemByName,
        keyword, // 关键字
        0, // 开始查询的树节点
        true, // 遍历方向
        0 // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentNodeInfo)) {
        await this.expendNode(this.currentNodeInfo, type)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        resolve(this.treeData)
        return
      }
      const res = await this.player.Native.ModelTree.getSubItems(node.data.item)
      const filterRes = _.filter(res, (el) => {
        return el?.name && el?.visible
      })
      resolve(filterRes)
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      this.treeData = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      // 删除地球GIS层
      this.treeData = _.filter(this.treeData, (item) => {
        return (
          item.itemType === this.modelTreeObj.ITEM_PR ||
          item.itemType === this.modelTreeObj.ITEM_NODE
        )
      })
      this.treeDataLoad = true
      this.objectTreeDataLoad = true
    },
    async destroyPhysical() {
      if (this.subjectPhysical) {
        await this.player.Native.PhysicsMgr.destroyPhysical(this.subjectPhysical)
        await this.player.Native.PhysicsMgr.destroyPhysical(this.objectPhysical)
      }
      this.subjectPhysical = null
      this.objectPhysical = null
    },
    // 开始检查
    async startCheck() {
      if (this.checkBtnLoading) return
      if (!this.subjectNode || !this.objectNode) {
        this.$message.warning('请选择碰撞主/客体')
        return
      }
      await this.player.Native.ModelTree.setSelectItem(0)
      this.tableData.length = 0
      this.tableLoading = true
      this.checkBtnLoading = true
      const subjectInfo = await this.player.Native.ModelTree.getItemInfo(this.subjectNode)
      const objectInfo = await this.player.Native.ModelTree.getItemInfo(this.objectNode)
      const subjectNodePtr = subjectInfo.nodePtr
      const objectNodePtr = objectInfo.nodePtr
      if (subjectNodePtr && objectNodePtr) {
        const isAncestor1 = await this.player.Native.NodeProxy.isAncestor(
          subjectNodePtr,
          objectNodePtr
        )
        if (isAncestor1) {
          this.objectPhysical = await this.player.Native.PhysicsMgr.addPhysical({
            node: objectNodePtr,
            mass: 1,
            createMode: 0,
            shapeMode: 1,
          })
          this.subjectPhysical = await this.player.Native.PhysicsMgr.addPhysical({
            node: subjectNodePtr,
            mass: 0,
            createMode: 0,
            shapeMode: 1,
          })
        } else {
          this.subjectPhysical = await this.player.Native.PhysicsMgr.addPhysical({
            node: subjectNodePtr,
            mass: 0,
            createMode: 0,
            shapeMode: 1,
          })
          this.objectPhysical = await this.player.Native.PhysicsMgr.addPhysical({
            node: objectNodePtr,
            mass: 1,
            createMode: 0,
            shapeMode: 1,
          })
        }
        const collisionRes = await this.player.Native.PhysicsMgr.saveCollisionTestLog()
        parser.parseString(collisionRes, (err, result) => {
          if (err) {
            this.$message.error(err)
          } else {
            console.log('xml-转-json', result)
            if (!result.root.record) {
              this.$message.warning('当前主/客体之间无碰撞点')
            } else {
              this.tableData = _.map(result.root.record, (it) => {
                const item = it.$
                const posArr = item.Point.split(',')
                return {
                  mainName: item.massA === '1' ? item.NodeB : item.NodeA,
                  guestName: item.massA === '1' ? item.NodeA : item.NodeB,
                  checkTime: result.root.$.startTime,
                  xPosition: posArr[0],
                  yPosition: posArr[1],
                  zPosition: posArr[2],
                }
              })
            }
          }
        })
        this.destroyPhysical()
      } else {
        this.$message.error('当前主/客体节点不存在')
      }
      this.tableLoading = false
      this.checkBtnLoading = false
    },
    // 重置碰撞预览颜色
    async resetNodeMaterial() {
      if (this.materialObj.previewSubNodePtr && this.materialObj.subMaterial) {
        await this.player.Native.NodeProxy.setNodeMaterial(
          this.materialObj.previewSubNodePtr,
          this.materialObj.subMaterial
        )
      }
      if (this.materialObj.previewObNodePtr && this.materialObj.obMaterial) {
        await this.player.Native.NodeProxy.setNodeMaterial(
          this.materialObj.previewObNodePtr,
          this.materialObj.obMaterial
        )
      }
      this.materialObj = this.$options.data().materialObj
      EventBus.$emit('materialNodeChange', false)
    },
    async rowClick(row) {
      try {
        if (this.locatingStatus) return
        this.locatingStatus = true
        await this.resetNodeMaterial()
        const treeData = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
        const rootNode = treeData[0]?.nodePtr
        if (rootNode) {
          this.player.Native.Camera.moveToPos(
            [parseFloat(row.xPosition), parseFloat(row.yPosition), parseFloat(row.zPosition)],
            rootNode,
            10,
            1
          )
          this.materialObj.previewSubNodePtr = await this.player.Native.NodeProxy.findFirstNodeByName(
            rootNode,
            row.mainName
          )
          this.materialObj.previewObNodePtr = await this.player.Native.NodeProxy.findFirstNodeByName(
            rootNode,
            row.guestName
          )
          if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
            this.materialObj.subMaterial = await this.player.Native.NodeProxy.getNodeMaterial(
              this.materialObj.previewSubNodePtr
            )
            this.materialObj.obMaterial = await this.player.Native.NodeProxy.getNodeMaterial(
              this.materialObj.previewObNodePtr
            )
            const newSubMaterial = await this.player.Native.NodeProxy.copyMaterial(
              this.materialObj.subMaterial
            )
            const newObMaterial = await this.player.Native.NodeProxy.copyMaterial(
              this.materialObj.obMaterial
            )
            await this.player.Native.NodeProxy.setMaterialDiffuse(newSubMaterial, 0xff0000ff)
            await this.player.Native.NodeProxy.setMaterialDiffuse(newObMaterial, 0x00ff00ff)
            await this.player.Native.NodeProxy.setNodeMaterial(
              this.materialObj.previewSubNodePtr,
              newSubMaterial
            )
            await this.player.Native.NodeProxy.setNodeMaterial(
              this.materialObj.previewObNodePtr,
              newObMaterial
            )
            EventBus.$emit('materialNodeChange', this.materialObj)
          } else {
            this.$message.warning('未查找到模型节点')
          }
        }
        this.locatingStatus = false
      } catch (error) {
        this.locatingStatus = false
      }
    },
    // 保存检查结果
    resultSave(row) {
      const filterEvent = new CustomEvent('openCollisionEdit', {
        detail: {
          ...row,
        },
      })
      window.dispatchEvent(filterEvent)
    },
    materialNodeChange(data) {
      if (!data) {
        this.materialObj = this.$options.data().materialObj
      } else {
        this.materialObj = Object.assign(this.materialObj, data)
      }
    },
  },
  beforeDestroy() {
    this.resetNodeMaterial()
    EventBus.$off('listMaterialNodeChange', this.materialNodeChange)
  },
  async created() {
    this.getModelTreeDatas()
    this.materialObj = this.collisionMaterialObj
    EventBus.$on('listMaterialNodeChange', this.materialNodeChange)
  },
}
</script>
<style lang="scss" scoped>
.button-bg-img {
  background: url('../../../assets/images/button_blue.png');
  background-size: 100% 100%;
}
.new-collision-check {
  ::v-deep .el-button {
    background-color: rgb(67 153 174 / 35%) !important;
    background-image: none !important;
    border: 1px solid #629eaa !important;
    border-radius: 2px !important;
    height: 36px !important;
  }
  ::v-deep .el-button:hover,
  ::v-deep .el-button:focus {
    background-image: none !important;
  }
  ::v-deep .el-input__inner {
    background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
    border: none !important;
    background-size: 100% 100% !important;
    border-radius: unset !important;
  }
  .new-collision-table {
    ::v-deep .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: transparent !important;
    }
    ::v-deep .el-table__row.el-table__row--striped {
      background: linear-gradient(0deg, #17c5dc5e, #1de3fd1a);
    }
    ::v-deep .el-table__body .current-row {
      background: linear-gradient(0deg, #986c36, #986c3666);
    }
  }
  .item-select-box {
    ::v-deep .el-input__suffix .el-icon-arrow-up::before {
      content: '';
      background: url('../../../assets/images/cockpitNew/arrow-down.png') no-repeat;
      width: 10px;
      height: 8px;
      display: inline-block;
      background-size: contain;
    }
  }
}
::v-deep {
  // .el-input__inner {
  //   border-color: rgb(0 255 245);
  //   background-color: transparent;
  //   color: #fff !important;
  // }
  .el-tree-node.is-current > .el-tree-node__content,
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: rgba(4, 190, 228, 0.267) !important;
    color: #18bdd4 !important;
  }
  .el-tree .is-current .el-tree-node__label,
  .el-tree .is-current .ivu-tree-title {
    color: unset !important;
  }
  .el-tree-node__label {
    color: unset !important;
  }
  .el-scrollbar__wrap {
    width: 100% !important;
  }
  .el-tree-node:focus > .el-tree-node__content,
  .el-tree-node__content:hover,
  .el-upload-list__item:hover {
    background-color: rgba(4, 190, 228, 0.267) !important;
  }
  // .el-input__inner:focus {
  //   border-color: #18bdd4 !important;
  //   color: #fff !important;
  // }
  .el-tree-node > .el-tree-node__children {
    overflow: unset !important;
  }
  .el-table__empty-text {
    display: unset !important;
  }
  .el-table__empty-block::before {
    display: none;
  }
  .el-table .cell {
    cursor: default;
  }
}
.el-tree {
  background: linear-gradient(180deg, rgba(4, 87, 105, 0.9) 0%, rgba(1, 58, 70, 0.9) 93.96%),
    linear-gradient(0deg, #45f2eb, #45f2eb);
  color: #fff;
}
::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: #415c7a;
}
::-webkit-scrollbar-thumb {
  background: #16ded4b8;
}
</style>
